// Azure AD B2C認証の設定ファイル
import config from './config';

// // Azure AD B2Cの設定
// export const msalConfig = {
//   auth: {
//     clientId: "9850a791-a38f-44fd-9ab3-78b599e4bf6b", // アプリケーション（クライアント）ID
//     authority: "https://smeibancloud.b2clogin.com/smeibancloud.onmicrosoft.com/B2C_1_Smeibanpfmain_login", // 例: https://contoso.b2clogin.com/contoso.onmicrosoft.com/B2C_1_signupsignin
//     knownAuthorities: ["smeibancloud.b2clogin.com"], // 認証局のドメイン
//     redirectUri: config.appUrl, // リダイレクトURI（環境に応じて切り替え）
//     postLogoutRedirectUri: config.appUrl, // ログアウト後のリダイレクトURI（環境に応じて切り替え）
//   },
//   cache: {
//     cacheLocation: "sessionStorage", // キャッシュの保存場所（sessionStorageまたはlocalStorage）
//     storeAuthStateInCookie: false, // IEとEdgeのブラウザ互換性のため
//   }
// };

// Azure AD B2Cの設定
export const msalConfig = {
  auth: {
    clientId: "9850a791-a38f-44fd-9ab3-78b599e4bf6b", // アプリケーション（クライアント）ID
    authority: "https://smeibancloud.b2clogin.com/smeibancloud.onmicrosoft.com/B2C_1_Smeibanpfmain_login", // 例: https://contoso.b2clogin.com/contoso.onmicrosoft.com/B2C_1_signupsignin
    knownAuthorities: ["smeibancloud.b2clogin.com"], // 認証局のドメイン
    redirectUri: "/",          // 相対にしておけば FD 経由でもそのまま戻る
    postLogoutRedirectUri: "/"
  },
  cache: {
    cacheLocation: "sessionStorage", // キャッシュの保存場所（sessionStorageまたはlocalStorage）
    storeAuthStateInCookie: false, // IEとEdgeのブラウザ互換性のため
  }
};


// ログイン要求の設定
export const loginRequest = {
  scopes: [
    "openid", 
    "profile",
    "offline_access" // リフレッシュトークンのためのスコープ
  ] // 要求するスコープ
};

// MSALで使用するAPIエンドポイントとスコープの設定
// 注意: このサンプルではAPI呼び出しは実装しません
export const protectedResources = {
  apiEndpoint: {
    endpoint: "<APIエンドポイントURL>",
    scopes: ["<APIスコープ>"], // 例: https://<テナント名>.onmicrosoft.com/api/read
  },
};
